import type {
  PurchasePolicyAdditionalData,
  PurchasePolicyInput,
} from '../../../redux/reducer/v2/purchasePolicy';

/**
 * If the user fast forwards to PaymentMSI page, we need to redirect them back to the coverages page to pick a plan and coverages.
 * It checks if the application data is missing payment plans or optional coverages.
 * @param input User Input Data
 * @param additionalData Additional Data
 * @returns True if either payment plans or optional coverages are undefined, false otherwise.
 */
export const shouldRedirectToCoverages = (
  input: PurchasePolicyInput,
  additionalData: PurchasePolicyAdditionalData,
) => {
  return (
    additionalData.paymentPlans === null || input.optionalCoverages === null
  );
};
